import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../commons/Auth';
import {
  BilledField,
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PaymentsDataField,
} from '../../../commons/DataTable';
import { withRouter } from 'react-router-dom';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function RoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  showEmptyTableMessage,
  truncateTable,
  subAdmins = false,
  profile,
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable && (
        <Field
          title="Nome Fornitore"
          source="supplier.businessName"
          className="text-left"
        />
      )}
      {!truncateTable && <Field title="Numero Fattura" source="number" />}
      {!truncateTable && (
        <DateTimeField title="Data Fattura" source="date" format="DD/MM/YYYY" />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Mese Rend."
          source="accountability"
          format="MM/YYYY"
        />
      )}
      {!truncateTable && (
        <Field title="Responsabile cliente" source="admin.businessName" />
      )}
      <CurrencyField
        title="Imponibile"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="Importo da Incassare"
        source="gross"
        className="txt-table-right"
      />
      <PaymentsDataField title="Pagato" source="payments" type="total" />
      <CurrencyField
        title={`Quota responsabile (${
          subAdmins ? '1' : profile?.type === 'AGENCY' ? '7' : '10'
        }%)`}
        source="adminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
      />
      <BilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        subAdmins={subAdmins}
        visible={!truncateTable && newIsAdmin}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iafs.0.number"
        visible={!truncateTable && newIsAdmin}
      />
    </DataTable>
  );
}

export default withRouter(RoyaltyTable);
